import { COLLECTIONS } from "constants/action-types";

export const collectionHistoryPush = (payload) => ({
    payload,
    type: COLLECTIONS.COLLECTION.HISTORY.PUSH,
});

export const collectionHistoryUpdate = (undo, redo) => ({
    payload: {
        redo,
        undo,
    },
    type: COLLECTIONS.COLLECTION.HISTORY.UPDATE,
});
